const isSysco = (organizationName?: string) => (
  organizationName?.toLowerCase() === "sysco"
);

export default isSysco;
